import React from 'react';
import { Button, IconArrow } from 'gatorcomponents';
import * as Styles from './MyAds.styles';

const MyAds = ({ goToInsights }) => (
  <Styles.Container>
    <Styles.Title>Meus anúncios</Styles.Title>
    <Button
      label="Voltar para insights"
      variant="secondary"
      size="medium2"
      iconLeft={<IconArrow direction="left" />}
      onClick={goToInsights}
    />
  </Styles.Container>
);

export default MyAds;
